<script>
    import {_, number, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";
    import {NAVAL_ICONS, shipXpKeys, resolveTitle} from './naval-items.js';

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        // The XP granted per item — this is what the localization row is keyed on
        // ("shipXp1000Title"), not the quantity the pack grants.
        const amount = Number(gameItem.amount);
        const keys = shipXpKeys(amount);

        itemDetails.title = resolveTitle({
            key: keys.title,
            fallback: 'Ship XP',
            translate: (k) => $_(k, {values: {AMOUNT: $number(amount)}}),
        });
        itemDetails.description = resolveTitle({
            key: keys.description,
            fallback: '',
            translate: (k) => $_(k, {values: {AMOUNT: $number(amount)}}),
        });
        itemDetails.amount = item.amount;
        itemDetails.icon = NAVAL_ICONS.shipXp;
        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
